'use strict';

var ObjectToArray = function(obj) {
    var arr = [];

    if (typeof obj === 'undefined' || obj === null) return arr;

    for (var key in obj) {
        if (!obj.hasOwnProperty(key)) continue;
        obj[key].$id = key;
        arr.push(obj[key]);
    }

    return arr;
};

module.exports = ObjectToArray;